import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { getMessage } from '@/helpers/utils';
import { questionService } from '../../services/questionService';

export const useCreateQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      questionService
        .create(payload)
        .then(response => {
          const { status, data } = response;
          const message = getMessage(data);
          if (status === 201) {
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.question.list],
            });
            return { data, success: true, message };
          }
          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
